
import React, { useEffect, useState } from 'react';
import { Avatar, Box, CircularProgress, List, ListItem, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import Logo from "../Logo.jsx";
import { useStyles } from "../../styles.jsx";
import request from '../../api';
import { getRestauranteFromStorage, ensureRestauranteLoaded } from '../../services/selectedRestaurante';

const CategorySidebar = ({ loading, error, categories, categoryClickHandler }) => {
    const [restaurante, setRestaurante] = useState({});
    const styles = useStyles(restaurante);

    useEffect(() => {
        const loadRestaurante = async () => {
            let rest = getRestauranteFromStorage();

            if (!rest) {
                rest = await ensureRestauranteLoaded();
            }

            setRestaurante(rest || {});

        };

        loadRestaurante();
    }, []);



    // Ordenar categorias pelo campo Ordem (tratando diferentes casos)
    const sortedCategories = React.useMemo(() => {
        console.log('CategorySidebar - Recalculando categorias ordenadas');
        console.log('CategorySidebar - Categories received:', categories);

        if (!categories || !Array.isArray(categories)) {
            console.log('CategorySidebar - Sem categorias ou não é array');
            return [];
        }

        // Filtrar apenas categorias visíveis
        const visibleCategories = categories.filter((category) => category.visivel);
        console.log('CategorySidebar - Categorias visíveis após filtro:', visibleCategories.map(c => c.nome));

        const sorted = [...visibleCategories].sort((a, b) => {
            // Verificar diferentes variações do campo ordem
            const orderA = a.Ordem ?? a.ordem ?? a.ORDEM ?? 999999;
            const orderB = b.Ordem ?? b.ordem ?? b.ORDEM ?? 999999;

            console.log(`CategorySidebar - Comparando ${a.nome} (ordem: ${orderA}) com ${b.nome} (ordem: ${orderB})`);

            // Converter para número se for string
            const numOrderA = typeof orderA === 'string' ? parseInt(orderA, 10) || 999999 : orderA;
            const numOrderB = typeof orderB === 'string' ? parseInt(orderB, 10) || 999999 : orderB;

            return numOrderA - numOrderB;
        });

        console.log('CategorySidebar - Categorias após ordenação:', sorted.map(c => ({
            nome: c.nome,
            ordem: c.Ordem || c.ordem || c.ORDEM
        })));

        return sorted;
    }, [categories]);

    
    return (
        <Box style={{
            position: 'fixed',
            left: 0,
            top: 0,
            width: '16.666%', // equivalente a md={2}
            height: '100vh',
            zIndex: 2,
            backgroundColor: restaurante.corPrimaria || '#fa5b6d',
            display: 'flex',
            flexDirection: 'column'
        }}>
            {/* Logo fixo no topo */}
            <Box style={{
                flexShrink: 0,
                display: 'flex',
                justifyContent: 'center',
                paddingTop: 24,
                paddingBottom: 16
            }}>
                <Box
                    onClick={() => categoryClickHandler({ nome: '', id: 0 })}
                    style={{ cursor: 'pointer' }}
                >
                    <Logo size={styles.logo} logo={restaurante.logo} />
                </Box>
            </Box>

            {/* Container scrollável para as categorias */}
            <Box style={{
                flex: 1,
                overflowY: 'auto',
                overflowX: 'hidden',
                WebkitOverflowScrolling: 'touch',
                scrollbarWidth: 'thin',
                scrollbarColor: 'rgba(255,255,255,0.3) transparent',
                paddingBottom: '360px',
                marginBottom: '0'
            }}>
                {
                    loading ? (
                        <Box style={{ display: 'flex', justifyContent: 'center', padding: 20 }}>
                            <CircularProgress />
                        </Box>
                    ) : error ? (
                        <Box style={{ padding: 16 }}>
                            <Alert severity="error">{error}</Alert>
                        </Box>
                    ) : (
                        <List style={{ padding: 0, margin: 0 }}>
                            {
                                sortedCategories.map((category, idx) => (
                                    <ListItem
                                        button
                                        key={`${category.id}-${idx}`}
                                        onClick={() => categoryClickHandler(category)}
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            padding: '20px 8px',
                                            minHeight: '200px'
                                        }}
                                    >
                                        <Avatar
                                            alt={category.nome}
                                            src={category.foto}
                                            style={{ width: 120, height: 120, marginBottom: 12 }}
                                        />
                                        <Typography
                                            variant="body1"
                                            align="center"
                                            style={{
                                                fontSize: '1.2rem',
                                                color: '#fff',
                                                fontWeight: 600,
                                                textShadow: '0 1px 2px rgba(0,0,0,0.6)',
                                                letterSpacing: '0.02em',
                                                textTransform: 'capitalize',
                                                wordWrap: 'break-word',
                                                overflowWrap: 'break-word',
                                                hyphens: 'auto',
                                                lineHeight: '1.2',
                                                maxWidth: '100%',
                                                padding: '0 8px'
                                            }}
                                        >
                                            {category.nome}
                                        </Typography>
                                    </ListItem>
                                ))
                            }
                        </List>
                    )
                }
            </Box>
        </Box>
    );
};

export default CategorySidebar;
